import { AuthProvider } from '@aposphaere/core-kit'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import './App.css'
import Event from './components/events'
import ViewportProvider from './contexts/viewPort'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import Pages from './pages'
import { secondsToMilliseconds } from 'date-fns'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: secondsToMilliseconds(60), // The minimum time before data is refetched
      notifyOnChangeProps: 'tracked',
    },
  },
})

const App: React.FC = () => (
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />

      <ViewportProvider>
        <Router>
          <Event />
          <Pages />
        </Router>
      </ViewportProvider>
    </QueryClientProvider>
  </AuthProvider>
)

export default App
